import { Injectable } from '@angular/core';
import {
    decodeUtf8,
    encodeUtf8,
    formatFormDataRequest,
    getFileExt,
    getProperty
} from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from './apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { ExpDocks_, ExpRequests_, ExpResults_, extJson, extPdf } from '@documalis/_const/const';
import { ParseService } from './parse.service';
import { VariableListService } from './variablelist.service';
import { DynIndexService } from './dynindex.service';
import { EditorService } from './editor.service';
import { Router } from '@angular/router';
import { IndexedDbService } from './indexeddb.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {

  private docId: string = '';
  private url: string = '';
  private applicationType: string = '';
  private donwlRes: any;
  private fileName: string = '';
  private status: boolean = false;
  private paramRequest: string = '';
  private winSize = {width: 800, height: 1000};

  constructor(private translate: TranslateService, private api: ApiV6Service,
    protected _messageService: MessagesService, private router: Router, private indexedDbService: IndexedDbService,) { }

  public setDocId(aDocId) {
      this.docId = aDocId;
  }

  public getUrl() {
      return this.url;
  }

  public getRequest() {
    return this.paramRequest;
  }

  public getWinSize() {
    return this.winSize;
  }

  public getStatus() {
      return this.status;
  }

  public async downloadDocument(aAction, aDocInfos, aGetUrl = false) {
    await this.execLoadAction(aAction, { Docid: this.docId });
    if (this.getStatus() === false) {
      return;
    }
    if (aAction === 'getdocumentcopy') {
      this.applicationType = this.getAppFromType(extPdf);
      this.fileName = 'C' + this.docId + extPdf;
    } else {
      this.applicationType = this.getAppFromType(getProperty(aDocInfos, 'Extension'));
      this.fileName = getProperty(aDocInfos, 'Name') + getProperty(aDocInfos, 'Extension');
    }
    this.setDlLinkOrUrl(aGetUrl);
  }

  public async downLoadBatch(aRequest, aType, aFilename) {     
    await this.execLoadAction('getbatchfile', aRequest);
    if (this.getStatus() === false) {
      return;
    }
    this.applicationType = aType;
    this.fileName = aFilename;
    this.setDlLinkOrUrl(false);
  }

  public async exportExcel(aName, aExportType) {
    const formData = new FormData();
    this.fileName =  aName + '.xlsx';
    formData.append('filename',this.fileName);
    formData.append('exporttype', JSON.stringify(aExportType));
    await this.execLoadAction('exportexcel', formData);
      if (this.getStatus() === false) {
          return;
      }
    this.setDlLinkOrUrl(false);
  }

  public async execDownloadVerFile(aFileName, aOrigin) {
    this.fileName = this.getFileName(aFileName, aOrigin, this.docId);
    this.setApplicationType();
    const formData = formatFormDataRequest({ Docid: this.docId });
    await this.execLoadAction(aOrigin, formData);
    if (this.getStatus() === false) {
      return;
    }
    this.setDlLinkOrUrl(false);
  }

  public async downloadAtfFile(aFileName, aGetUrl) {
    this.fileName = aFileName;
    this.setApplicationType();
    const formData = this.createFormDataRequest(this.fileName);
    await this.execLoadAction('dwnlattachedfile', formData);
    if (this.getStatus() === false) {
      return;
    }
    this.setDlLinkOrUrl(aGetUrl);
  }

  public async getContentUrl(aFileName) {
    try {
      this.url = '';
      this.paramRequest = '';
      this.fileName = aFileName;
      this.setApplicationType();
      const formData = this.createFormDataRequest(this.fileName);
      const wRes = await lastValueFrom(this.api.execUrlAction('dwnlattachedgedfile', formData));
      if (wRes['url']) {
        this.url = wRes['url'];
      }
      if (wRes['request']) {
        this.paramRequest = wRes['request'];
      }
      this.status = true;
    } catch (error) {
      this.status = false;
      this._messageService.addErrorMsg(this.translate.instant('Dwnl_KO'));      
    }
  }

  public async getUrlRequest(aIndex) {
    let wRes: any;
    let wParseService: ParseService;
    let wVariableListService: VariableListService;
    let wDynIndexService: DynIndexService;
    let wEditorService: EditorService;
    let wRequest = JSON.parse(this.paramRequest);
    let wValue = '';
    let wContent = '';
    try {
        this.url = '';
        this.paramRequest = '';      
        wParseService = new ParseService(this.router);
        wVariableListService = new VariableListService(wParseService, this.indexedDbService);
        wDynIndexService = new DynIndexService;
        wEditorService = new EditorService(wDynIndexService, wVariableListService, this.translate, this.indexedDbService);
        wEditorService.variableListService.parseService.setBasketName('');
        wEditorService.variableListService.parseService.setVariable(aIndex);
        wRequest.indexlist.index.map(item => {
                wValue = decodeUtf8(wEditorService.variableListService.parseService.execParse(item.value));
                item.DefaultValue = wValue;
                item.valdefault = wValue;
                item.value = wValue;
                return item;  
            }
        );            
        wContent = 'search='+wRequest.page+'&displaymenu='+wRequest.showmenu+'&reqname=' + btoa(wRequest.requestname);
        for (let i = 0; i < wRequest.indexlist.index.length; i++) { 
            wContent += '&parname'+i+'='+btoa(wRequest.indexlist.index[i].name);
            wContent += '&parvalue'+i+'='+btoa(wRequest.indexlist.index[i].value);
        }

        const formData = new FormData();
        formData.append('content', wContent);
        wRes = await lastValueFrom(this.api.execUrlAction('getcrypt', formData));
        let lastChar = wRes.content.slice(-1);
        if (lastChar === '%') {
            wContent = wRes.content.slice(0, -1);
        }
        this.url = wRequest.url + '/#/login?Content=' + wContent;
        this.winSize.width = wRequest.width !== undefined ? wRequest.width : 800;
        this.winSize.height = wRequest.height !== undefined ? wRequest.height : 1000;
        this.status = true;        
    } catch (error) {
        this.status = false;
        this._messageService.addErrorMsg(this.translate.instant('Dwnl_KO'));      
        console.log(error);
    } finally {
        wParseService = null;
        wVariableListService = null;
        wDynIndexService = null;
        wEditorService = null;
    }
  }

  public async getAtfFile(aAtfName) {
    this.fileName = aAtfName;
    const wExt = getFileExt(this.fileName).toUpperCase();
    this.applicationType = this.getAppFromType(wExt);
    const formData = this.createFormDataRequest(this.fileName);
    if (wExt.toLowerCase() === extPdf) {
      await this.execLoadAction('dwnlattachedfile', formData);
    } else {
      await this.execLoadAction('convertattachedfile', formData);
    }
    if (this.getStatus() === false) {
      return;
    }
    this.setDlLinkOrUrl(true);
  }

  public async doExport(aAction) {
    const formData = this.setParamExport(aAction);
    await this.execLoadAction('exportparam', formData);
    if (this.getStatus() === false) {
      return;
    }
    this.setDlLinkOrUrl(false);
  }

  private setParamExport(aExportType) {
    const formData = new FormData();
    switch (aExportType) {
      case 'docks':
        this.fileName = ExpDocks_ + new Date().getTime() + extJson;
        formData.append('exporttype', 'ParamDocks');
        break;
      case 'requests':
        this.fileName = ExpRequests_ + new Date().getTime() + extJson;
        formData.append('exporttype', 'Requests');
        break;
      case 'results':
        this.fileName = ExpResults_ + new Date().getTime() + extJson;
        formData.append('exporttype', 'Results');
        break;
    }
    formData.append('filename', this.fileName);
    return formData;
  }

  private setApplicationType() {
    const wExt = getFileExt(this.fileName).toUpperCase();
    this.applicationType = this.getAppFromType(wExt);
  }

  private setDlLinkOrUrl(aGetUrl) {
    this.url = '';
    this.paramRequest = '';
    if (aGetUrl === true) {
      this.url = window.URL.createObjectURL(this.donwlRes.data);
    } else {          
      if (this.fileName) {
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob([this.donwlRes.data], { type: this.applicationType }));
          downloadLink.setAttribute('download', this.fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this._messageService.addSuccess(this.translate.instant('Dwnl_OK'));
      }
    }
  }

  private createFormDataRequest(aAtfName) {
    const wRequest = {
      Docid: this.docId,
      AtfName: encodeUtf8(aAtfName),
      applicationType: this.applicationType,
    };
    return formatFormDataRequest(wRequest);
  }

  private getFileName(aName, aOrigin, aDocId) {
    if (aOrigin === 'getversioncopy') {
        return 'C' + aDocId + extPdf;
    } else {
        return aName;
    }
  }

  private getAppFromType(aType) {
    let wRes = 'application/octet-stream';
    if (aType === '') {
        return wRes;
    }

    if (aType.toLowerCase() === extPdf) {
        wRes = 'application/pdf';
        return wRes;
    }

    if (aType.toLowerCase() === extJson) {
      wRes = 'application/json';
      return wRes;
    }  
    return wRes;
  }

  private async execLoadAction(aAction, aRequest) {
    try {
      this.donwlRes = {};
      const wRes = await lastValueFrom(this.api.execPostUrlFileAction(aAction, aRequest));
      this.donwlRes = this.checkDl(wRes);      
      this.status = true;
    } catch (error) {
      this.status = false;
      this._messageService.addErrorMsg(this.translate.instant('Dwnl_KO'));
    }    
  }

  private checkDl(aData) : {} | false {
    let wResponse: any = {};
    if (aData.type !== undefined) {
        if (aData.type === 'application/pdf' || aData.type === 'application/octet-stream' || aData.type === 'application/json') {
            return (wResponse = {
                status: true,
                data: aData,
            });
        }
    }
    if (aData.status !== undefined) {
        if (aData.status === false) {
          throw new Error(this.translate.instant('Load_Data_KO'));
        }
    }
    throw new Error(this.translate.instant('Load_Data_KO'));
  }
}
